module.exports = __webpack_public_path__ + "3976df8dc887d828f900116d3d23957b.svg";